<template>
  <div class="file-upload-list-item d-flex"
       :class="{'file-upload-list-item--undo': removed}">
    <div class="va-row"
         v-if="removed">
      <div class="flex md12 xs12">
        <vuestic-file-upload-undo @recover="recoverFile" />
      </div>
    </div>
    <div class="va-row align--center"
         v-else>
      <div class="file-upload-list-item__name flex xs12 lg8 ellipsis"
           @click="showImage(file, true)">
        <img :src="fileImage">
        <span>{{ file.name }}</span>
      </div>
      <div class="file-upload-list-item__size xs12 lg1">
        <!-- {{ file.size }} -->
      </div>
      <div class="file-upload-list-item__date xs12 lg1">
        <!-- <span>{{ $t('fileUpload.uploadedOn')}} {{ file.date }}</span> -->
      </div>
      <!-- TODO Use global classes instead -->
      <div class="file-upload-list-item__button-container flex xs12 lg2">
        <button type="button"
                class="btn-text btn-text--primary"
                @click="removeFile"
                v-if="!disabled">
          {{ $t('fileUpload.delete') }}
        </button>
      </div>
    </div>
    <large-image :isShowFileImage="isShowFileImage"
                 :filesList="filesList"
                 :bigImage="bigImage"
                 :fileUrl="fileUrl"
                 :curFile="curFile"
                 @closeLargeImage="closeFileImage"
                 @showImage="showImageInit" />
  </div>
</template>

<script>
import VuesticFileUploadUndo from './VuesticFileUploadUndo'
import largeImage from '../../../components/MerchantKYC/components/components/large-image.vue'

export default {
  name: 'vuestic-file-upload-list-item',
  components: {
    VuesticFileUploadUndo: VuesticFileUploadUndo,
    largeImage,
  },
  props: {
    file: {
      type: Object,
    },
    filesList: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      removed: false,
      fileTypes: {
        doc: require('../../../assets/images/fileType/doc.png'),
        docx: require('../../../assets/images/fileType/docx.png'),
        jpeg: require('../../../assets/images/fileType/jpeg.png'),
        jpe: require('../../../assets/images/fileType/jpeg.png'),
        jpg: require('../../../assets/images/fileType/jpg.png'),
        pdf: require('../../../assets/images/fileType/pdf.png'),
        png: require('../../../assets/images/fileType/png.png'),
        xls: require('../../../assets/images/fileType/xls.png'),
        xlsx: require('../../../assets/images/fileType/xlsx.png'),
      },
      emptyFile: require('../../../assets/images/fileType/empty-file.png'),
      bigImage: '',
      fileUrl: '',
      isShowFileImage: false,
      curFile: null,
    }
  },
  mounted () {
    this.curFile = this.file
  },
  computed: {
    fileType () {
      try {
        if (this.file.url) {
          return this.file.url.substring(this.file.url.lastIndexOf('.') + 1)
        }
        if (typeof this.file.image === 'string') {
          return this.file.image.substring(this.file.image.lastIndexOf('.') + 1)
        }
        return this.file.image.image.substring(this.file.image.image.lastIndexOf('.') + 1)
      } catch (error) {}
    },
    fileImage () {
      if (this.fileTypes[this.fileType]) {
        return this.fileTypes[this.fileType]
      } else {
        return this.emptyFile
      }
    },
  },
  methods: {
    showFilePreview () {},
    removeFile () {
      this.$emit('remove')
      // this.removed = true;
      // setTimeout(() => {
      //   if (this.removed) {
      //     this.$emit("remove");
      //     this.removed = false;
      //   }
      // }, 2000);
    },
    recoverFile () {
      this.removed = false
    },
    /**
     * params file 文件
     * params isShowFile 是否打开文件 否 只赋值，不打开
     */
    showImage (file, isShowFile) {
      this.curFile = file
      let that = this
      let reader = new FileReader()
      // .pdf .jpg/.jpeg/.jpe/.png .doc/.docx .xls/.xlsx
      let imageType = ['image/jpeg', 'image/png', 'jpg', 'jpeg', 'jpe', 'png']
      let fileType = [
        'application/pdf',
        'application/msword',
        'application/vnd',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'docx',
        'doc',
        'xls',
        'xlsx',
        'pdf',
      ]
      if (file.size === 'NaN undefined') {
        if (imageType.some((type) => file.image.indexOf(type) > 0)) {
          that.bigImage = file.image
          that.isShowFileImage = true
        // } else if (fileType.some((type) => file.image.indexOf(type) > 0)) {
        } else {
          var aFile = document.createElement('a')
          aFile.target = '_blank'
          aFile.href = file.image
          aFile.download = file.image.name
          aFile.style.display = 'none'
          document.body.appendChild(aFile)
          aFile.click()
          aFile.remove()
        }
        return
      }
      reader.readAsDataURL(file.image)
      reader.onloadstart = function () {
        // console.log('文件上传处理......')
      }
      // 操作完成
      reader.onload = function (e) {
        // file 对象的属性 图片：展示 文件：跳转
        let result = reader.result.split(';')[0]
        if (imageType.some((type) => result.indexOf(type) > 0)) {
          that.bigImage = reader.result
          that.isShowFileImage = true
        } else {
          let herf = window.URL.createObjectURL(file.image)
          window.open(herf)
        }
        // } else if (
        //   fileType.some((type) => reader.result.indexOf(type) > 0) &&
        //   isShowFile
        // ) {
        //   let herf = window.URL.createObjectURL(file.image)
        //   window.open(herf)
        // } else if (
        //   fileType.some((type) => reader.result.indexOf(type) > 0) &&
        //   !isShowFile
        // ) {
        //   that.bigImage = ''
        //   that.fileUrl = window.URL.createObjectURL(file.image)
        // } else {
        //   that.bigImage = ''
        //   that.fileUrl = null
        // }
      }
    },
    closeFileImage () {
      this.bigImage = null
      this.isShowFileImage = false
      this.curFile = null
    },
    showImageInit (file, isShowFile) {
      this.curFile = file
      this.bigImage = file.image
      let that = this
      let reader = new FileReader()
      // .pdf .jpg/.jpeg/.jpe/.png .doc/.docx .xls/.xlsx
      let imageType = ['image/jpeg', 'image/png', 'jpg', 'jpeg', 'jpe', 'png']
      // let fileType = [
      //   'application/pdf',
      //   'application/msword',
      //   'application/vnd',
      //   'application/vnd.ms-excel',
      //   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      //   'docx',
      //   'doc',
      //   'xls',
      //   'xlsx',
      //   'pdf',
      // ]
      if (file.size === 'NaN undefined') {
        if (imageType.some((type) => file.image.indexOf(type) > 0)) {
          that.bigImage = file.image
          that.isShowFileImage = true
        // } else if (fileType.some((type) => file.image.indexOf(type) > 0)) {
        } else {
          that.bigImage = ''
          that.fileUrl = file.image
        }
        return
      }
      reader.readAsDataURL(file.image)
      reader.onload = function (e) {
        let imageType = ['image/jpeg', 'image/png']
        if (imageType.some((type) => reader.result.indexOf(type) > 0)) {
          that.bigImage = reader.result
          that.fileUrl = ''
        } else {
          that.bigImage = ''
          that.fileUrl = window.URL.createObjectURL(file.image)
        }
        this.isShowFileImage = true
      }
    },
  },
}
</script>

<style lang='scss'>
.file-upload-list-item {
  & + & {
    margin-top: 0.5rem;
  }

  background-color: $white;
  box-shadow: $sidebar-box-shadow;
  padding: 0.6rem 1rem;

  &__size {
    margin: auto;
    color: $gray-light;
  }

  &__date {
    margin: auto;
    color: $gray-light;
  }

  &--undo {
    background: none;
    box-shadow: none;
  }

  @include media-breakpoint-up(lg) {
    &__button-container {
      text-align: right;
    }
  }
  .file-upload-list-item__name {
    cursor: pointer;
    img {
      width: 25px;
      position: relative;
      top: -2px;
    }
    span {
      padding-left: 10px;
    }
  }
}
</style>
